var modulePolling = function() {
  var $ = jQuery,
      _this;

  var module = {
    params: {
      action: 'get_posts',
      categoryName: "",
      lastPolledOffset: 0,
      reachedMaxOffset: false,
      postsPerPage: 5,
      renderAs: 'news'
    },

    isPolling: false,

    init: function() {
        _this = this;
        this.modifyDOM();
        this.addEvents();
    },

    modifyDOM: function() {
    },

    addEvents: function() {
      $(window).on('scroll', _this.eventHandlers.handleScroll);
    },

    eventHandlers: {
      handleScroll: function(e) {
        var shouldPoll = false;

        if ($(window).scrollTop() + $(window).height() === $(document).height()) {
          shouldPoll = true;
        } else if ( ( $(window).scrollTop() + $(window).height() - $(document).height() ) > -1000) {
          shouldPoll = true;
        }

        if (shouldPoll && !_this.isPolling) {
          if (_this.params.reachedMaxOffset) {
            return;
          } else {
            _this.helpers.poll();
          }
        }
      }
    },

    helpers: {
      poll: function() {
         var spinner = new Spinner({
           lines: 10, length: 8, width: 2, radius: 10, color: '#000', top: '100%'
         }).spin($('#js-infinite-scroll-spinner')[0]);

         _this.isPolling = true;

         $.get('/wp/wp-admin/admin-ajax.php', {
          action: _this.params.action,
          offset: _this.params.lastPolledOffset || _this.params.postsPerPage,
          posts_per_page: _this.params.postsPerPage,
          category_name: _this.params.categoryName,
          render_as: _this.params.renderAs
         }).success(function(response) {
          var $el = $(response),
              $container = $('.js-news-container');

          spinner.stop();
          _this.isPolling = false;

          if ($el.length === 0) {
            _this.params.reachedMaxOffset = true;
          } else {
            _this.params.lastPolledOffset = (_this.params.lastPolledOffset || _this.params.postsPerPage) + _this.params.postsPerPage;
            $container.append($el);
          }
        });
       }
    }
  };

  module.init();
};
